import { render } from "./TriangleAlertSVG.vue?vue&type=template&id=6c71d224"
import script from "./TriangleAlertSVG.vue?vue&type=script&lang=js"
export * from "./TriangleAlertSVG.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__